import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

/**
 * Hook to set up global query client access for cache invalidation
 * This allows services to invalidate caches without direct access to React Query
 */
export const useQueryClientSetup = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Store query client globally for service access
    (window as any).__queryClient = queryClient;
    
    return () => {
      // Clean up on unmount
      delete (window as any).__queryClient;
    };
  }, [queryClient]);
};